import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs';
import { APIConfigMapping, HTTPAPIConfig, VlDataService, VlHttpService } from 'shared-library';
import { SharedService } from '../../Services/shared.service';

@Injectable({
  providedIn: 'root'
})
export class PageRearrangeService {

   constructor( private sharedService:SharedService,private dataService: VlDataService,private toaster:ToastrService,private httpService: VlHttpService,){
      
    }


  /**
   * Rearranges the pages based on the provided order.
   * @param pages - Array of page objects
   * @param order - Array of page IDs defining the new order
   * @returns Rearranged array of pages
   * @throws Error if invalid input is provided
   */
  rearrangePages(pages: any[], order: string[]): any {
    // Input validation
    if (!pages?.length || !order?.length) {
      return pages;
    }

    // Create a map of pages for O(1) lookup
    const pageMap = new Map(pages.map(page => [page.pageId, page]));
    const validOrderIds = new Set(pageMap.keys());

    // Filter valid IDs and add missing pages at the end
    const finalOrder = [
      ...order.filter(id => validOrderIds.has(id)),
      ...pages
        .map(page => page.pageId)
        .filter(id => !order.includes(id))
    ];

    // Map the IDs to their corresponding pages
    return finalOrder.map(id => {
      const page = pageMap.get(id);
      if (!page) {
        throw new Error(`Invalid page ID: ${id}`);
      }
      return page;
    });
  }

  /**
   * makes an api call to update the application with the new page order
   * @param applicationId 
   * @param pageIdsList  updated order of page IDs
   */
  editApplication(applicationId:string, pageIdsList:string[]) {
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['EDIT_APPLICATION']);

      apiConfig.postData = {
        application_id: applicationId,
        page_ids_list:pageIdsList
      }
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: any) => {
          const applicationData = this.sharedService.getApplicationDataEntire();
          applicationData['page_ids_list'] = pageIdsList;
          this.sharedService.setApplicationDataEntire(applicationData);   
          this.sharedService.setApplicationData(applicationData);
            // this.toaster.success("Changes Successfully Applied");
        },
        error: (err: any) => {
          if(err?.status == 403) {
            this.toaster.error('You do not have permission to access this resource.');
          }else{
            this.toaster.error(err.error.result);
          }
        }
      })
    }


  /**
   * Updates the order array by adding or removing page IDs
   * @param currentOrder - Current array of page IDs
   * @param applicationId - application Id
   * @param pageId - Page ID to add or remove
   * @param action - 'add' or 'remove'
   * @returns Updated order array
   */
  updateOrder(applicationId: string, currentOrder: string[], pageId: string, action: 'add' | 'remove') {
    if (!pageId) {
      this.toaster.error('Invalid page ID');
      return;
    }
    let order = [...currentOrder];
    if (action === 'add' && !currentOrder.includes(pageId)) {
      order = [...currentOrder, pageId];
    }
    if (action === 'remove') {
      order = currentOrder.filter(id => id !== pageId);
    }

    this.editApplication(applicationId, order);
  }

  
}
